export const ServiceRequestsPageTabs = {
  allRequests: "All",
  billableRequests: "Billable",
  myRequests: "My Requests",
};
